import React from 'react'

import {
  FieldSpec,
  DateTimeField,
  EnumField,
  LinkedField,
  PaginatedTable,
  PercentField,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'
import { skuit } from 'src/services/skuit'
import { Audit } from 'src/api/models'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  facility: { id: 'facility', label: 'Facility', renderer: RelatedLinkedField(ValueField, 'name') },
  sku: { id: 'sku', label: 'SKU', renderer: RelatedLinkedField(ValueField, 'sku') },
  auditType: { id: 'auditType', label: 'Type', renderer: EnumField(Audit.Type) },
  createdOn: {
    id: 'createdOn',
    label: 'Created On',
    ordering: 'created_on',
    renderer: DateTimeField,
  },
  status: { id: 'statusDisplay', label: 'Status', renderer: ValueField },
  accuracyScore: { id: 'accuracyScore', label: 'Accuracy Score', renderer: PercentField },
}

const exportFields = [
  'name',
  'status',
  'accuracy_score',
  'completed_on',
  'created_on',
  'guid',
  'reconciled_on',
  'started_on',
  'updated_on',
]

export const AuditListTable = (props: ListTableProps) => {
  const { paginator, fields, extraActions } = props

  return (
    <>
      <PaginatedTable
        title="Audits"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.audits.export,
        }}
      />
    </>
  )
}
